import { render } from "./MaterialsTable.vue?vue&type=template&id=59f899b3&scoped=true"
import script from "./MaterialsTable.vue?vue&type=script&lang=js"
export * from "./MaterialsTable.vue?vue&type=script&lang=js"

import "./MaterialsTable.vue?vue&type=style&index=0&id=59f899b3&lang=scss&scoped=true"

import exportComponent from "/home/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f899b3"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QToggle});
